import { useLazyQuery, useMutation, useReactiveVar } from '@apollo/client'
import {
    ShowGlobalSnackbarMutation,
    ShowGlobalSnackbarMutationProps,
    ShowGlobalSnackbarRequest,
} from '@deltek/specification-client/core/Configurations/GlobalSnackbar'
import { ListingLevel } from '@deltek/specification-client/core/Models/product'
import { ProductListingDetailsAutoSuggestQuery } from 'bpm/api/graphQL/queries/productSearch.queries'
import { ProductListingDetailsAutoSuggestResult } from 'bpm/api/graphQL/types/product.types'
import React, { FC } from 'react'
import { RadioType } from './AddProductTypes'
import ExistingFamilyAutoCompleteInput from './ExistingFamilyAutoCompleteInput'
import FamilyRadioSection from './FamilyRadioSection'
import NewFamilySection from './NewFamilySection'
import { addProductDialogState } from './addProductFormHandler'

type Props = {
    isCategoriesLoading: boolean
}

const FamilySection: FC<Props> = ({ isCategoriesLoading }) => {
    const { type, familyRadio } = useReactiveVar(addProductDialogState)

    const [showGlobalSnackbar] = useMutation<
        ShowGlobalSnackbarRequest,
        ShowGlobalSnackbarMutationProps
    >(ShowGlobalSnackbarMutation)

    const [
        callAutoSuggest,
        { loading: autoSuggestLoading, data: autoSuggestData },
    ] = useLazyQuery<ProductListingDetailsAutoSuggestResult>(
        ProductListingDetailsAutoSuggestQuery,
        {
            fetchPolicy: 'network-only',
            onError: () => {
                showGlobalSnackbar({
                    variables: {
                        message: 'Something went wrong with autosuggest',
                        variant: 'error',
                        id: 'autosuggest_Error',
                    },
                })
            },
        }
    )

    return (
        <>
            {type === ListingLevel.PremiumProprietary && <FamilyRadioSection />}
            {familyRadio === RadioType.Existing ? (
                <ExistingFamilyAutoCompleteInput
                    autoSuggestData={autoSuggestData}
                    callAutoSuggest={callAutoSuggest}
                    autoSuggestLoading={autoSuggestLoading}
                />
            ) : (
                <NewFamilySection
                    autoSuggestData={autoSuggestData}
                    callAutoSuggest={callAutoSuggest}
                    isCategoriesLoading={isCategoriesLoading}
                />
            )}
        </>
    )
}

export default FamilySection
